<template>
  <ConfirmOperator class="no-border"
    type="primary"
    iconType="md-exit"
    iconSize="18"
    text="退出登录"
    title="退出登录"
    :content="content"
  />
</template>

<script>
import ModalOperatorMixin from '@/components/commons/ModalOperatorMixin'
import router from '@/router/index'
import {loginout} from '@/api/login'
import {mapMutations} from 'vuex';
export default {
  name: 'Quit',
  mixins: [
    ModalOperatorMixin,
  ],

  components: {},

  computed: {
    content() {
      return '确定退出登录吗？'
    },
  },
  methods: {
    ...mapMutations(['SET_AUTHORIZES']),
    onSubmit() {
      if (this.$closeCentitIM != undefined) {
        this.$closeCentitIM();
      }
      loginout()
      this.$store.commit('SET_AUTHORIZES', { allAuthorizes: {}, authorizes: {}})
      localStorage.setItem('authorizesInfo', {})
      // 刷新退出
      location.reload();
      // router.replace({
      //   name: 'login',
      // })
    },
  },
}
</script>
<style scoped>
.no-border.ivu-btn{
  border: 1px solid transparent;
}
</style>
